import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, elementAt } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseLocalStorageService } from './base-local-storage.service';
import { LocalStorageConstants } from '../constants/local-storage-constants';

@Injectable({
  providedIn: 'root'
})
export class BaseHttpClientService {

  constructor(
    private httpClient: HttpClient,
    private localStorageService: BaseLocalStorageService,
  ) {

  }
  handleError(error: HttpErrorResponse) {
    window.dispatchEvent(new CustomEvent('closeSpinner'));
    console.warn(error);
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {

      // Client errors
      errorMessage = `Error: ${error.error.message}`;
      if (error.status === 401) {
        window.dispatchEvent(new CustomEvent('session-expired'));
        return throwError(error);
      }
    } else {
      // Server errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

      if (error.status === 401) {
        window.dispatchEvent(new CustomEvent('session-expired'));
        return throwError(error);
      }
    }
    return throwError(error);
  }

  public sendGetRequest(baseUrl: string, requeredToken: boolean, tenantKey:string|null = null) {
    let headers = new HttpHeaders();

    if (requeredToken) {
      headers = headers.append('Authorization', "Bearer " + this.localStorageService.getItem(LocalStorageConstants.AccessToken));
    }
    headers = headers.append('X-Token', environment.x_token);
    headers = tenantKey ? headers.append('HttpContextTenantKey', tenantKey) : headers;

    return this.httpClient.get<any>(baseUrl, { headers })
      .pipe(catchError(this.handleError));
  }

  public sendGetRequestParameters(endPointApi: string, parameterId: any, requeredToken: boolean, baseUrl: string, tenantKey:string|null = null) {
    type headerType = {[key: string] : string}
    let headers:headerType = {}

    if (requeredToken) {
      headers["Authorization"]="Bearer " + this.localStorageService.getItem(LocalStorageConstants.AccessToken);
    }
    if (tenantKey) {
      headers["HttpContextTenantKey"]=tenantKey;
    }
    headers["X-Token"]=environment.x_token;
    return this.httpClient.get<any>(`${this.getUrl(baseUrl)}${endPointApi}${parameterId}`, { headers })
      .pipe(catchError(this.handleError));
  }

  public sendGetRequestQueryParameters(baseUrl: string, parameter: any, requeredToken: boolean) {
    let headers: any;

    if (requeredToken) {
      headers = {
        'Authorization': "Bearer " + this.localStorageService.getItem(LocalStorageConstants.AccessToken),
        'X-Token': environment.x_token
      };
    }else{
      headers = {
        'X-Token': environment.x_token
      };
    }
    return this.httpClient.get<any>(baseUrl, { params: new HttpParams({ fromString: 'accountCode=' + parameter }), headers })
      .pipe(catchError(this.handleError));
  }
  /**
    *Metodo para obtener la url a donde se va a consumir el api
    *
    * @private
    * @param {string} baseulr url, en caso de que esta sea null se pondra por defecto la de concreto webapi
    * @return {*}  {string} retornar la url para consumir el api
    * @memberof DataService
    */
  private getUrl(baseulr: string): string {
    if (!baseulr)
      return environment.restApi.msB2C;
    return baseulr;
  }

  public sendPostRequest(endPointApi: string, contract: any, requeredToken: boolean, baseUrl: string,withCredentials:boolean= false, tenantKey:string|null = null) {
    let headers = new HttpHeaders();

    if (requeredToken) {
      headers = headers.append('Authorization', "Bearer " + this.localStorageService.getItem(LocalStorageConstants.AccessToken));
    }
    headers = headers.append('X-Token', environment.x_token);
    headers = headers.append('Content-Type', "application/json");
    headers = tenantKey ? headers.append('HttpContextTenantKey', tenantKey) : headers;
    return this.httpClient.post<any>(`${this.getUrl(baseUrl)}${endPointApi}`, JSON.stringify(contract), { headers: headers, withCredentials: withCredentials  })
      .pipe(
        catchError(this.handleError)
      );
  }


  public sendPostFormDataRequest(baseUrl: string, contract: FormData, requeredToken: boolean) {
    let headers: any;

    if (requeredToken) {
      headers = {
        'Authorization': "Bearer " + this.localStorageService.getItem(LocalStorageConstants.AccessToken),
        'X-Token': environment.x_token
      };
    }else{
      headers = {
        'X-Token': environment.x_token
      };
    }

    return this.httpClient.post<any>(baseUrl, contract, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  public sendPostRequestParameters(baseUrl: string, parameterCityId: any, requeredToken: boolean) {
    let headers: any;

    if (requeredToken) {
      headers = {
        'Authorization': "Bearer " + this.localStorageService.getItem(LocalStorageConstants.AccessToken),
        'X-Token': environment.x_token
      };
    }else{
      headers = {
        'X-Token': environment.x_token
      };
    }

    return this.httpClient.post<any>(baseUrl + parameterCityId, null, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  public getDownloadFile(urlFile: string, mimeTypeFile: string) {
    this.httpClient.get(urlFile, { responseType: 'arraybuffer' })
      .subscribe(response => this.downloadFile(response, mimeTypeFile));
  }

  downloadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }

  public sendPostRequestCredentials(endPointApi: string, contract: any, requeredToken: boolean, baseUrl?: string,withCredentials:boolean= false, tenantKey?:string) {
    let headers = new HttpHeaders();

    if (requeredToken) {
      headers = headers.append('Authorization', "Bearer " + this.localStorageService.getItem(LocalStorageConstants.AccessToken));
    }
    headers = headers.append('X-Token', environment.x_token);
    headers = headers.append('Content-Type', "application/json");
    headers = tenantKey ? headers.append('HttpContextTenantKey', tenantKey) : headers;

    return this.httpClient.post<any>(`${this.getUrl(baseUrl!)}${endPointApi}`, JSON.stringify(contract), { headers: headers, withCredentials: withCredentials  })
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }public sendPostRequestCredentialsCustomToken(endPointApi: string, contract: any, requeredToken: boolean, baseUrl?: string,withCredentials:boolean= false, tenantKey:string = null,customToken:string=null) {
    let headers = new HttpHeaders();

    if (requeredToken) {
      headers = headers.append('Authorization', "Bearer " + customToken);
    }

    headers = headers.append('X-Token', environment.x_token);
    headers = headers.append('Content-Type', "application/json");
    headers = tenantKey ? headers.append('HttpContextTenantKey', tenantKey) : headers;

    return this.httpClient.post<any>(`${this.getUrl(baseUrl)}${endPointApi}`, JSON.stringify(contract), { headers: headers, withCredentials: withCredentials  })
      .pipe(
        catchError(this.handleError)
      );
  }


  showSpinner() {
    window.dispatchEvent(new CustomEvent('showSpinner'));
  }

  closeSpinner() {
    window.dispatchEvent(new CustomEvent('closeSpinner'));
  }

}
